import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisibilityService {

  private isTabVisibleSubject = new BehaviorSubject<boolean>(true);
  isTabVisible$ = this.isTabVisibleSubject.asObservable();

  constructor(private zone: NgZone) {
    document.addEventListener('visibilitychange', () => {
      this.zone.run(() => {
        const isVisible = !document.hidden;
        this.isTabVisibleSubject.next(isVisible);
      });
    });
  }
}
